module.exports = __webpack_public_path__ + "img/hospitals.257f24fc.png";